export const initializeGA = async (measurementId: string) => {
  let script1 = document.createElement("script");
  script1.src = "https://www.googletagmanager.com/gtag/js?id=" + measurementId;
  script1.async = true;
  document.body.appendChild(script1);

  let script2 = document.createElement("script");
  script2.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'GA_MEASUREMENT_ID');`;
  document.body.appendChild(script2);
}
